import React, { useEffect, useContext, useState } from 'react';
import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png";
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';
import {  getDashboardData, savePerssonalDetails } from '../../../Utils/api';
import { useNavigate } from 'react-router-dom';
import { formateDate, getStorage, goBack, isEmpty, setStorage } from '../../../Utils/common';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { formValidation } from '../../../Utils/formValidation';
import RadioButtons from '../../../components/ui/RadioButtons';
import ContextDashboard from '../../../Context/ContextDashboard';
import ProgressBar from "../../../components/ProgressBar/ProgressBar";



const initialData = {
    dob: "",
    maritalStatus: "",
    email: "",
    gender: "",
    spouseName: "",
    fatherName: "",
    aadhaarLast4: "",
};

const options = [
    { label: "Male", value: "1", name: "gender" },
    { label: "Female", value: "2", name: "gender" },
];

const marriedOptions = [
    { label: "Single", value: "1" },
    { label: "Married", value: "2" },
    { label: "Divorced", value: "3" },
];

function CapturPersonalInformation() {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState({});
    const [formData, setFormData] = useState(initialData);
    const [fullName, setFullName] = useState();
    const [formDataError, setFormDataError] = useState(initialData);
    const [progressBar, setProgressBar] = useState(getStorage("step_percent"));
    const [showSteps, setShowSteps] = useState(-1);
    const [toggle, setToggle] = useState(true);
    const [dobFromAPI, setDobFromAPI] = useState(false);
    const [dobSource, setDobSource] = useState(""); // Track source: "PAN" or "API"
    const [fatherNameFromAPI, setFatherNameFromAPI] = useState(false);
    const [fatherNameSource, setFatherNameSource] = useState(""); // Track source: "PAN" or "API"
    const [isApplicationSubmitted, setIsApplicationSubmitted] = useState(false);
    const navigate = useNavigate();
    const { message, setMessage, logout, setps,handleEvent } = useContext(ContextDashboard);

    const submit = async () => { // Add async here
        console.log("=== FORM VALIDATION DEBUG ===");
        console.log("Form Data before validation:", formData);
        console.log("Father Name before validation:", formData.fatherName);
        
        const error = formValidation(formData, ["fatherName"]); // Temporarily exclude fatherName from validation
        console.log("Validation errors:", error);
        console.log("=============================");
        
        setFormDataError({ ...formDataError, ...error });
    
        const param = {
            profile_id: getStorage("cust_profile_id") || "", 
            event_name: "personal_details",
            gender: formData.gender,
            personal_email: formData.email,
            dob: formateDate(formData.dob),
            marital_status_id: formData.maritalStatus,
            spouse_name: formData.maritalStatus === "2" ? formData.spouseName : undefined,
            father_name: formData.fatherName ? formData.fatherName.trim() : "",
            aadhaar_last_4: formData.aadhaarLast4 ? formData.aadhaarLast4.trim() : "",
        };

        // Debug logging
        console.log("=== PERSONAL DETAILS SUBMISSION DEBUG ===");
        console.log("Form Data:", formData);
        console.log("API Parameters:", param);
        console.log("Father Name Value:", formData.fatherName);
        console.log("Aadhaar Last 4 Value:", formData.aadhaarLast4);
        console.log("==========================================");
    
        if (formData.maritalStatus !== "2") {
            delete error.spouseName;
        }
    
        if (isEmpty(error)) {
            setLoading(true);
            try {
                // First, save the personal details
                const resp = await savePerssonalDetails(param);
                
                
                setLoading(false);
    
                if (resp?.data?.Status === 1) {
                    console.log("=== BACKEND RESPONSE DEBUG ===");
                    console.log("Full Response:", resp?.data);
                    console.log("Data Object:", resp?.data?.Data);
                    console.log("Data Keys:", Object.keys(resp?.data?.Data || {}));
                    console.log("Profile Details:", resp?.data?.Data?.profile_details);
                    console.log("Father Name in Response:", resp?.data?.Data?.profile_details?.father_name);
                    console.log("=================================");
                    
                    setResponse(resp?.data);
                    setStorage("next_step", resp?.data?.Data?.next_step);
                    setStorage("step_percent", resp?.data?.Data?.step_percentage);
                    setMessage({ type: 'success', msg: resp?.data?.Message, place: "global" });
                    
                    // Verify the father's name was saved by fetching dashboard data
                    console.log("=== VERIFYING FATHER'S NAME SAVED ===");
                    const verifyParams = {
                        profile_id: getStorage("cust_profile_id") || "",
                    };
                    getDashboardData(verifyParams).then(verifyResp => {
                        if (verifyResp?.data?.Status === 1) {
                            console.log("Verification Response:", verifyResp?.data);
                            console.log("Father Name in Verification:", verifyResp?.data?.Data?.profile_details?.father_name);
                            
                            // Check if father's name was actually saved
                            if (verifyResp?.data?.Data?.profile_details?.father_name === formData.fatherName) {
                                console.log("✅ SUCCESS: Father's name was saved successfully!");
                            } else {
                                console.log("❌ ISSUE: Father's name was not saved. Expected:", formData.fatherName, "Got:", verifyResp?.data?.Data?.profile_details?.father_name);
                            }
                        }
                    });
                    
                    handleEvent(getStorage('next_step'));
    
                    
                } else if (resp?.data?.Status === 4) {
                    logout();
                } else {
                    setMessage({ type: 'error', msg: resp?.data?.Message });
                }
            } catch (err) {
                setLoading(false);
                console.error('Error saving personal details:', err);
                setMessage({ type: 'error', msg: "Error saving personal details" });
            }
        }
    };
    
    // Helper function to calculate age based on DOB
    const calculateAge = (dob) => {
        const today = new Date();
        const birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    // Helper function to format date as D/M/Y
    const formatDateForDisplay = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Helper function to convert D/M/Y to YYYY-MM-DD for input
    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        // If already in YYYY-MM-DD format, return as is
        if (dateString.includes('-') && dateString.length === 10) {
            return dateString;
        }
        // If in D/M/Y format, convert to YYYY-MM-DD
        if (dateString.includes('/')) {
            const parts = dateString.split('/');
            if (parts.length === 3) {
                const day = parts[0].padStart(2, '0');
                const month = parts[1].padStart(2, '0');
                const year = parts[2];
                return `${year}-${month}-${day}`;
            }
        }
        return dateString;
    };

    const onChange = (e) => {
        let { name, value } = e.target;
        console.log(`Field changed: ${name} = "${value}"`);
        setFormData({ ...formData, [name]: value });

        if (formDataError[name]) {
            setFormDataError({ ...formDataError, [name]: "" });
        }
        
        // Reset API indicators when user manually changes fields
        if (name === 'fatherName') {
            setFatherNameFromAPI(false);
            setFatherNameSource("");
        }
        
        // Validate Aadhaar last 4 digits
        if (name === 'aadhaarLast4') {
            // Only allow numbers and limit to 4 digits
            const numericValue = value.replace(/\D/g, '').slice(0, 4);
            setFormData({ ...formData, [name]: numericValue });
            
            if (numericValue.length !== 4) {
                setFormDataError({ ...formDataError, [name]: "Please enter exactly 4 digits" });
            } else {
                setFormDataError({ ...formDataError, [name]: "" });
            }
            return;
        }
    };

    const onChangeDate = (date) => {
        const age = calculateAge(date);

        if (age < 18) {
            setFormDataError({ ...formDataError, dob: "You must be at least 18 years old." });
        } else {
            setFormData({ ...formData, dob: date });
            setFormDataError({ ...formDataError, dob: "" });
            setDobFromAPI(false); // Reset API indicator when user manually changes DOB
            setDobSource(""); // Reset source when manually changed
        }
    };

    useEffect(() => {
        // First check if application is already submitted from storage
        const storedApplicationStatus = getStorage("application_status");
        if (storedApplicationStatus === "submitted") {
            console.log("Application already submitted from storage - setting frozen state");
            setIsApplicationSubmitted(true);
        }

        // Then check for PAN verification data (highest priority)
        const panDob = getStorage("pan_dob");
        const panFatherName = getStorage("pan_father_name");
        
        if (panDob || panFatherName) {
            setDobFromAPI(!!panDob);
            setDobSource(panDob ? "PAN" : "");
            setFatherNameFromAPI(!!panFatherName);
            setFatherNameSource(panFatherName ? "PAN" : "");
            setFormData(prev => ({
                ...prev,
                dob: panDob || "",
                fatherName: panFatherName || "",
            }));
        }

        // Then fetch dashboard data for other fields
        const params={
            profile_id: getStorage("cust_profile_id") || "", 
          };
          getDashboardData(params).then(resp=>{
            if (resp?.data?.Status===1){
        const dashboardData = resp?.data || {};
        if (dashboardData) {
            setFullName(dashboardData?.Data?.profile_details?.first_name); // Set the full name for display
            
            // Only update fields that weren't set from PAN verification
            setFormData(prev => ({
                ...prev,
                dob: prev.dob || dashboardData?.Data?.profile_details?.dob || "",
                maritalStatus: dashboardData?.Data?.profile_details?.marital_status_id || "",
                email: dashboardData?.Data?.profile_details?.personal_email || "",
                gender: dashboardData?.Data?.profile_details?.gender || "",
                fatherName: prev.fatherName || dashboardData?.Data?.profile_details?.father_name || "",
            }));
            
            // Update indicators if we got data from dashboard (not PAN)
            if (!panDob && dashboardData?.Data?.profile_details?.dob) {
                setDobFromAPI(true);
                setDobSource("API");
            }
            if (!panFatherName && dashboardData?.Data?.profile_details?.father_name) {
                setFatherNameFromAPI(true);
                setFatherNameSource("API");
            }

            // Check if application is already submitted
            const applicationStatus = dashboardData?.Data?.profile_details?.application_submitted;
            if (applicationStatus === 1 || applicationStatus === "1") {
                setIsApplicationSubmitted(true);
            }
        }
    }
});
    }, [logout]);

    useEffect(() => {
        if (!isEmpty(setps)) {
            checkStep(setps);
        }
    }, [setps]);

    const checkStep = (data) => {
        const steps = (data?.step_stage - 1);
        if (data?.step_complete_percent === 100) {
            setToggle(false);
        }
        setShowSteps(steps);
    };

    return (
        <>
         
            <ProgressBar value={`${progressBar}%`}>
                <div></div>
            </ProgressBar><br />
            
            {/* Application Submitted - Frozen State */}
            {isApplicationSubmitted && (
                <div style={{
                    backgroundColor: '#f8f9fa',
                    border: '2px solid #28a745',
                    borderRadius: '10px',
                    padding: '30px',
                    margin: '20px',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '60px', color: '#28a745', marginBottom: '20px' }}>
                        ✅
                    </div>
                    <h2 style={{ color: '#28a745', marginBottom: '15px' }}>
                        Application Already Submitted!
                    </h2>
                    <p style={{ color: '#666', fontSize: '16px', margin: '15px 0' }}>
                        Your application is currently under review. Our teammate will contact you soon.
                    </p>
                    <p style={{ color: '#888', fontSize: '14px', margin: '10px 0' }}>
                        You cannot edit your information until your current application status is closed.
                    </p>
                </div>
            )}

            {!isApplicationSubmitted && (
            <BoxWrapper className="w100">
                <div className="formmainBox flex">
                    <div className="left">
                        <div className='center gap4 pointer' onClick={() => goBack(navigate, "/my-dashboard/")}>
                            <img src={arrowIcon} alt="" /> <span>Back</span>
                        </div>
                    </div>
                    <div className="right">
                        <h2>Personal Information *</h2>
                        <p>Share with us a bit about yourself.</p>
                        <FormWrapper>
                            <Alert setMessage={setMessage} message={message} />
                            <div className="inputBox">
                                <Input
                                    label="Your Full Name"
                                    name="full_name"
                                    value={getStorage("fullName") || fullName}
                                    readOnly
                                />
                                <Input
                                    label="Personal Email"
                                    name="email"
                                    error={formDataError?.email}
                                    onChange={onChange}
                                    value={formData?.email}
                                    required={true}
                                />
                                <div style={{ position: 'relative' }}>
                                    {dobFromAPI && formData?.dob ? (
                                        // Show formatted date when fetched from API (non-editable)
                                        <div>
                                            <label style={{ 
                                                display: 'block', 
                                                marginBottom: '8px', 
                                                fontSize: '14px', 
                                                fontWeight: '500',
                                                color: '#333'
                                            }}>
                                                DOB <span style={{color: 'red'}}>*</span>
                                            </label>
                                            <div style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                fontSize: '14px',
                                                backgroundColor: '#f5f5f5',
                                                color: '#666',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}>
                                                <span>{formatDateForDisplay(formData?.dob)}</span>
                                                <span style={{
                                                    fontSize: '12px',
                                                    color: '#28a745',
                                                    fontWeight: 'bold'
                                                }}>
                                                    ✓ From {dobSource}
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        // Show editable date input when not from API
                                        <Input
                                            label="DOB"
                                            name="dob"
                                            type='date'
                                            error={formDataError?.dob}
                                            onChange={onChangeDate}
                                            value={formatDateForInput(formData?.dob)}
                                            required={true}
                                        />
                                    )}
                                </div>
                                <div style={{ position: 'relative' }}>
                                    <Input
                                        label="Father's Full Name"
                                        name="fatherName"
                                        error={formDataError?.fatherName}
                                        onChange={onChange}
                                        value={formData?.fatherName}
                                        required={true}
                                    />
                                    {fatherNameFromAPI && formData?.fatherName && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '35px',
                                            right: '10px',
                                            fontSize: '12px',
                                            color: '#28a745',
                                            fontWeight: '500',
                                            background: '#d4edda',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            border: '1px solid #c3e6cb'
                                        }}>
                                            ✓ From {fatherNameSource}
                                        </div>
                                    )}
                                </div>
                                <Input
                                    label="Aadhaar Last 4 Digits"
                                    name="aadhaarLast4"
                                    type="text"
                                    maxLength="4"
                                    error={formDataError?.aadhaarLast4}
                                    onChange={onChange}
                                    value={formData?.aadhaarLast4}
                                    required={true}
                                    placeholder="Enter last 4 digits of Aadhaar"
                                />
                                <Select
                                    label="Your Marital Status"
                                    name="maritalStatus"
                                    placeholder="--Select--"
                                    error={formDataError?.maritalStatus}
                                    onChange={onChange}
                                    value={formData?.maritalStatus}
                                    options={marriedOptions}
                                    required={true}
                                />
                                {formData.maritalStatus === "2" && (
                                    <Input
                                        label="Spouse Name"
                                        name="spouseName"
                                        onChange={onChange}
                                        value={formData.spouseName}
                                        error={formDataError?.spouseName}
                                    />
                                    
                                )}
                                {/* {formData.maritalStatus === "2" && (
                                    <Input
                                        label="Spouse Name"
                                        name="spouseName"
                                        onChange={onChange}
                                        value={formData.spouseName}
                                        error={formDataError?.spouseName}
                                    />
                                    
                                )} */}
                                <RadioButtons title='Select Gender' options={options} className="flex" value={formData.gender} error={formDataError.gender} onChange={onChange} required={true} />
                            </div>
                            <div className="button">
                                <Button title="Continue" onClick={submit} loading={loading} />
                            </div>
                        </FormWrapper>
                    </div>
                </div>
            </BoxWrapper>
            )}
        </>
    );
}

export default CapturPersonalInformation;
